export default "__VITE_ASSET__BDocmUcE__"